export default __webpack_public_path__ + "locales/it/DeleteThirdPartyDialog.json?hash=773123636b1b3e4d9469ce26036543a7";